import { app } from "@microsoft/teams-js";
import { useCallback } from "react";

import { isError } from "../services/ChannelApi";
import { userApi } from "../services/UserApi";

export const useHubspotChat = () => {
  const loadHubspotChat = useCallback(
    async (contextOrApiToken: app.Context | string, open?: boolean) => {
      if (!window.HubSpotConversations) {
        console.warn("HubSpotConversations is not defined");
        return;
      }

      const status = window.HubSpotConversations.widget.status();

      if (!status.loaded) {
        const tokenResponse = await userApi.getHubspotIdentityToken(contextOrApiToken);

        if (isError(tokenResponse)) {
          console.error(tokenResponse);
          return;
        }

        if (tokenResponse.token) {
          window.hsConversationsSettings = {
            identificationEmail: tokenResponse.email,
            identificationToken: tokenResponse.token,
          };
        }

        window.HubSpotConversations.widget.load({ widgetOpen: open });
      } else if (open) {
        window.HubSpotConversations.widget.open();
      }
    },
    []
  );

  return { loadHubspotChat };
};
